import { AudioManager } from "../../../AudioManager";
import { Orb } from "./Orb";

export class RayEffect extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, pBomb: {c: number, r: number}, pOrb: {c: number, r: number}) {
        
        super(scene);

        this.x = pBomb.c * Orb.SIZE;
        this.y = pBomb.r * Orb.SIZE;

        const dx = (pOrb.c - pBomb.c) * Orb.SIZE;
        const dy = (pOrb.r - pBomb.r) * Orb.SIZE;

        const l = Math.sqrt(dx * dx + dy * dy);
        const rotation = Math.atan2(dy, dx);
        
        const raySprite = new Phaser.GameObjects.Sprite(this.scene, 0, 0, "texture_atlas_6", "fx_electricity_01");
        raySprite.setOrigin(0, .5);
        raySprite.rotation = rotation;
        raySprite.scaleX = l / raySprite.width;
        this.scene.add.existing(raySprite);
        this.add(raySprite);

        raySprite.anims.play("ray");

        const numFrames = raySprite.anims.currentAnim.frames.length;
        const startFrame = raySprite.anims.currentAnim.frames[Math.floor(numFrames * Math.random())];
        raySprite.anims.setCurrentFrame(startFrame);

        AudioManager.playSound("color_bomb_zap", false, 1, Math.random() * .5 + 1);
    }
}
